import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Client } from '../Models/Client';
import { ClientAddress } from '../Models/ClientAddress';
import { Contact } from '../Models/Contact';

class ClientApi {
  static getClient(id: string) {
    return axios.get<Client>(`${API_URL}/api/client/${id}`, getAuthHeader());
  }
  static addUpdateClient(request: Client) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/client`,
      request,
      getAuthHeader()
    );
  }
  static getClientsList() {
    return axios.get<Client[]>(`${API_URL}/api/client`);
  }
  static GetDealerLocatorList() {
    return axios.get<Client[]>(`${API_URL}/api/client/dealerlocatorlist`);
  }
  static getClientAddress(id: string) {
    return axios.get<ClientAddress>(
      `${API_URL}/api/client/address/${id}`,
      getAuthHeader()
    );
  }
  static getClientAddresses(clientId: number) {
    return axios.get<ClientAddress[]>(
      `${API_URL}/api/client/address/list/${clientId}`,
      getAuthHeader()
    );
  }
  static addUpdateClientAddress(request: ClientAddress) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/client/address`,
      request,
      getAuthHeader()
    );
  }
  static deleteClientAddress(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/client/address/${id}`,
      getAuthHeader()
    );
  }
  static getContactsForClient(clientId: string) {
    return axios.get<Contact[]>(
      `${API_URL}/api/client/${clientId}/contacts`,
      getAuthHeader()
    );
  }
}

export default ClientApi;
